import styled from 'styled-components';

export const SelectBoxContainer = styled.div`
  min-width: 60px;
  position: relative;
  cursor: pointer;
`;

export const ContentWrapper = styled.div`
  background-color: #373245;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  gap: 5px;

  .placeholder {
    opacity: 0.6;
  }

  .disabled {
    opacity: 0.2;
  }
`;

interface ArrowProps {
  direction?: 'top' | 'bottom';
  isUse: boolean;
}

export const Arrow = styled.div<ArrowProps>`
  display: ${({ isUse }) => (isUse ? 'block' : 'none')};
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  position: relative;
  top: 4px;

  ${({ direction = 'bottom' }) =>
    direction === 'bottom'
      ? `
      border-top: 5px solid #999;
    `
      : `
      border-bottom: 5px solid #999;
    `}
`;
